export default "__VITE_ASSET__DfnhKU39__"